module.exports = __webpack_public_path__ + "img/shop-back.5444e7bf.png";